// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/calendar-x.js';

import { paths } from '../generated/calendar-x';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('calendar-x', Original, paths);
